import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const TabMenuContainer = styled.div`
    /* margin-left: 30px; */
    margin-left: 10px;
    /* ${media.mediumDevice`
        margin-left: 30px;
    `} */
`;
export const MenuItem = styled.li`
    /* width: 3rem; */
    height: 1.75rem;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    color: #000000;
    cursor: pointer;
    &:hover,
    :active {
        cursor: pointer;
        border-bottom: 3px solid #1010eb;
    }
    display: inline-flex;
    margin: 0 0 0 20px;
    /* ${media.mediumDevice`
        margin: auto 5px;
    `} */
    ${media.mobileDevice`    
    display:none; 
        background: ${(props) =>
            props.theme.calendarBackgroundColor} 0% 0% no-repeat padding-box;
    `}

    border-bottom:  ${(props) => (props.selected ? '3px solid #1010eb' : '')}
`;
